import { ref, watch } from '@vue/composition-api'
import EmailForm from '@/components/EmailForm/EmailForm'
import useMultipleForms from '@/compositions/useMultipleForms'
import useRequest from '@/compositions/useRequest'

export default ({
  props: {
    interval: Array,
    reportsArr: Array,
  },
  components: { EmailForm },
  setup(props, context) {
    const { refs, emit } = context
    const { $store } = context.root
    const period = ref(props.interval[1].value)
    const validationWarning = ref([])

    const reports = ref(props.reportsArr)

    const existingEmailForms = ref([])
    const { forms: emails, addForm: addEmailForm, removeForm: removeEmailForms } = useMultipleForms({ existingForms: existingEmailForms })
    const findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index)

    const { makeRequest: deleteReport, loading: deleteReportLoading } = useRequest({
      context,
      successMessage: 'Подписка на очет удалена!',
      request: id => $store.dispatch('orders/deleteReport', id),
    })

    const validateForms = () => {
      let valid = true
      const emailList = []
      validationWarning.value = []
      if (!emails) return valid
      emails.value.forEach((item) => {
        const form = refs[`email-${item}`][0]
        if (!form.validate()) valid = false
        if (form.formData.email) emailList.push(form.formData.email)
      })
      if (!emailList.filter(e => e !== '').length) {
        validationWarning.value.push('Необходимо ввести хотя бы один email')
        return false
      }
      const duplicatesEmails = [...new Set(findDuplicates(emailList))]
      if (duplicatesEmails.length) validationWarning.value.push('Дублирование получателей')
      if (validationWarning.value.length) valid = false
      return valid
    }

    const getFormData = () => {
      const arrayEmails = []
      emails.value.forEach((item) => {
        const form = refs[`email-${item}`][0]
        const data = form.getData()
        if (data.email !== '') arrayEmails.push(data.email)
      })
      return { emails: arrayEmails, interval: period.value }
    }

    const unsubscribe = async (id) => {
      const resp = await deleteReport(id)
      reports.value = resp.reports
    }

    const submit = () => {
      if (validateForms()) {
        emit('success', getFormData())
      }
    }

    watch(() => props.reportsArr, () => {
      reports.value = props.reportsArr
    })

    return {
      validationWarning,
      period,
      emails,
      existingEmailForms,
      deleteReportLoading,
      reports,
      addEmailForm,
      removeEmailForms,
      submit,
      unsubscribe,
    }
  },
})
